export default __webpack_public_path__ + "static/media/liked-icon.511fcfb8.svg";